import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "profile-header-widget" }
const _hoisted_2 = { class: "avatar-container" }
const _hoisted_3 = { class: "avatar-ring" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "profile-name" }
const _hoisted_6 = { class: "profile-email" }
const _hoisted_7 = { class: "menu-container" }
const _hoisted_8 = { class: "drawer-footer" }
const _hoisted_9 = {
  key: 0,
  class: "global-help-dot",
  title: "Guide updated"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_PanelMenu = _resolveComponent("PanelMenu")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_menu_toggle = _resolveComponent("ion-menu-toggle")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_menu = _resolveComponent("ion-menu")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_IonSplitPane = _resolveComponent("IonSplitPane")!
  const _component_HelpSheet = _resolveComponent("HelpSheet")!
  const _component_IonApp = _resolveComponent("IonApp")!

  return (_openBlock(), _createBlock(_component_IonApp, null, {
    default: _withCtx(() => [
      _createVNode(_component_IonSplitPane, { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_menu, {
            "content-id": "main-content",
            type: "overlay",
            onIonWillOpen: _ctx.menuOpened
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_content, { class: "drawer-content" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "profile-glow" }, null, -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "profile-waves" }, [
                      _createElementVNode("svg", {
                        viewBox: "0 0 100 30",
                        preserveAspectRatio: "none",
                        class: "waves-svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M0,30 C30,10 70,10 100,30 Z",
                          fill: "rgba(56, 128, 255, 0.08)"
                        }),
                        _createElementVNode("path", {
                          d: "M0,30 C45,18 55,18 100,30 Z",
                          fill: "rgba(0, 198, 255, 0.04)"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_ion_avatar, { class: "user-avatar" }, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              alt: _ctx.name,
                              src: _ctx.avatarImg ? _ctx.avatarImg : 'https://ui-avatars.com/api/?background=3880ff&color=ffffff&bold=true&name=' + _ctx.name
                            }, null, 8, _hoisted_4)
                          ]),
                          _: 1
                        })
                      ]),
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "avatar-status" }, null, -1))
                    ]),
                    _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.name), 1),
                    _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.email), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "profile-badge-container" }, [
                      _createElementVNode("span", { class: "profile-badge" }, "Jahaji Inhouse"),
                      _createElementVNode("span", { class: "profile-status-badge" }, [
                        _createElementVNode("span", { class: "status-indicator" }),
                        _createElementVNode("span", null, "Active")
                      ])
                    ], -1))
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_PanelMenu, {
                      model: _ctx.items,
                      class: "custom-panel-menu"
                    }, null, 8, ["model"])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_ion_menu_toggle, null, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "btn-logout",
                          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, [
                          _createVNode(_component_ion_icon, {
                            icon: _ctx.logOutOutline,
                            class: "logout-icon"
                          }, null, 8, ["icon"]),
                          _cache[7] || (_cache[7] = _createElementVNode("span", null, "Logout Session", -1))
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onIonWillOpen"]),
          _createVNode(_component_router_view, { id: "main-content" })
        ]),
        _: 1
      }),
      (_ctx.helpSlug)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "global-help-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.helpOpen = true)),
            "aria-label": "Help for this screen"
          }, [
            _cache[8] || (_cache[8] = _createTextVNode(" ? ", -1)),
            (_ctx.helpUpdated)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_HelpSheet, {
        open: _ctx.helpOpen,
        slug: _ctx.helpSlug,
        anchor: _ctx.helpAnchor,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.helpOpen = false)),
        onSeen: _ctx.updateHelpButton
      }, null, 8, ["open", "slug", "anchor", "onSeen"])
    ]),
    _: 1
  }))
}